<template lang="pug">
#etapas-laudo
    el-steps(:active='activeStep', finish-status='success', align-center)
        el-step(:title="$t('mensagens.laudos.preencherInformacoes')")
        el-step(:title="$t('mensagens.laudos.informarCar')")
        el-step(:title="$t('mensagens.laudos.enviarArquivo')")
        el-step(:title="$t('mensagens.laudos.resumo')")
    template(v-if='activeStep === 0')
        .form-container
            el-form(
                :model='form',
                :rules='rules',
                ref='form',
                label-width='150px',
                label-position='top'
            )
                el-form-item(
                    :label="$t('mensagens.laudos.areaFinanciada')",
                    prop='areaFinanciada'
                    style='width: 350px'
                )
                    el-input(
                        type='number',
                        v-model='form.areaFinanciada',
                        placeholder='Ex.: 325,25'
                    )
                el-form-item(
                    :label="$t('mensagens.laudos.periodoDeCobertura')",
                    prop='periodoCobertura'
                )
                    el-date-picker(
                        v-model='form.periodoCobertura',
                        type='daterange',
                        :range-separator="$t('mensagens.laudos.a')",
                        :start-placeholder="$t('mensagens.laudos.dataInicial')",
                        :end-placeholder="$t('mensagens.laudos.dataFinal')",
                        format='dd/MM/yyyy',
                        style='width: 350px'
                    )
                el-form-item(label='Cultura')
                    el-select(
                        v-model='form.cultura',
                        :placeholder="$t('mensagens.laudos.selecionaCultura')",
                        style='width: 350px'
                    )
                        el-option(
                            v-for='item in culturas',
                            :key='item.codigo',
                            :label='$t(`mensagens.cultura.${item.codigo}`)',
                            :value='item.id'
                        )
    template(v-if='activeStep === 1')
        .form-container
            p.bold {{ $t('mensagens.laudos.pesquisePeloCar') }}
            .pesquisa-car
                el-input(
                    v-model='carSelecionado',
                    :placeholder="$t('mensagens.laudos.digiteONumeroDoCar')",
                    prefix-icon='el-icon-search',
                    @keyup.native.enter='buscarCar'
                )
                el-button(
                    type='primary',
                    @click='buscarCar',
                    icon='el-icon-search'
                )
            .resultado-car(v-if='carExibicao')
                p {{ $t('mensagens.laudos.resultadoDaBusca') }}:
                .result-box
                    div
                        p.bold {{ carExibicao.codigo }}
                        p {{ $t('mensagens.laudos.areaHa') }}: {{ carExibicao.areaHa }}
                        p {{ $t('mensagens.laudos.localidade') }}: {{ carExibicao.municipioUF }}
                        p {{ $t('mensagens.laudos.situacao') }}: {{ validaSituacao(carExibicao.situacao) }}
                    el-button(
                        type='primary',
                        icon='el-icon-circle-plus-outline',
                        size='mini',
                        @click='adicionarCar'
                    )
            .resultado-car(v-else-if='buscando')
                p {{ $t('mensagens.laudos.buscandoInformacoesDoCar') }}...
            .lista-cars
                .container-cars-resultado(v-if='carsAdicionados.length > 0')
                    .car-item(
                        v-for='(car, index) in carsAdicionados',
                        :key='index'
                    )
                        .car-details
                            p.bold CAR: {{ car.codigo }}
                            p {{ $t('mensagens.laudos.localidade') }}: {{ car.municipioUF }}
                        el-button(
                            type='danger',
                            size='mini',
                            @click='removerCar(index)'
                        ) {{ $t('mensagens.comuns.remover') }}
                .container-cars-resultado(v-else)
                    .car-item-empty
                        p {{ $t('mensagens.laudos.naoHaNenhumCarAdicionado') }}
    template(v-if='activeStep === 2')
        .form-container
            p.bold {{ $t('mensagens.laudos.arquivoVetorial') }}
            el-upload.upload-demo(
                action='#',
                :file-list='fileList'
                :auto-upload='false'
                accept='.zip'
                :multiple='false'
                :limit='1'
                :on-change='handleFileChange'
                :on-remove='handleRemove'
                drag
            )
                div(slot='tip') Arquivo no formato <b>zip</b>
                i.el-icon-upload
                div
                    span {{ 'Arraste o arquivo aqui ou ' }}
                    el-link(type='primary') clique para fazer o upload
            .uploaded-file(v-if='fileList.length > 0')
                .file-row
                    i(el-icon-document) {{ fileList[0].name }}
                    .el-icon-check(style='color: green')
    template(v-if='activeStep === 3')
        .form-container
            p.bold {{ $t('mensagens.laudos.informacoesASeremAnalisadas') }}
            div.informacoes-analisadas
                p {{ $t('mensagens.laudos.areaFinanciada') }}: {{ form.areaFinanciada }}
                p {{ $t('mensagens.laudos.periodoDeCobertura') }}: {{ formatPeriodoCobertura }}
                p {{ $t('mensagens.laudos.cultura') }}: {{ formatCultura }}
            p.bold {{ $t('mensagens.laudos.carsInformados') }}
            div.informacoes-analisadas
                p(v-for='car in carsAdicionados', :key='car.codigo') {{ car.codigo }}
            p.bold {{ $t('mensagens.laudos.arquivoVetorial') }}
            span {{ fileList.length > 0 ? fileList[0].name : $t('mensagens.laudos.nenhumArquivoEnviado') }}
    .buttons
        BaseButton(
            @click='activeStep === 0 ? fecharModal() : voltar()',
            type='outline'
        ) {{ activeStep === 0 ? $t('mensagens.comuns.voltar') : $t('mensagens.laudos.etapaAnterior') }}
        BaseButton(v-if='activeStep === 3', @click='submit', type='primary', :disabled='submitting') {{ $t('mensagens.laudos.solicitar') }}
        BaseButton(v-else, @click='proximo', type='primary') {{ $t('mensagens.laudos.proximaEtapa') }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';
import LaudosService from '@/services/LaudosService';
import BaseButton from '../vegaComponents/BaseButton.vue';

export default {
    name: 'EtapasLaudo',
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },
    components: {
        BaseButton
    },
    data() {
        return {
            activeStep: 0,
            form: {
                areaFinanciada: '',
                periodoCobertura: [],
                cultura: ''
            },
            culturas: null,
            rules: {
                areaFinanciada: [
                    {
                        required: true,
                        message: this.$t('mensagens.laudos.informeAreaFinanciada'),
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[0-9]+(\.[0-9]{1,4})?$/,
                        message: this.$t('mensagens.laudos.numeroMaximoDecimais'),
                        trigger: 'blur'
                    }
                ],
                periodoCobertura: [
                    {
                        type: 'array',
                        required: true,
                        message: this.$t('mensagens.laudos.informePeriodoDeCobertura'),
                        trigger: 'change'
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value && value.length === 2) {
                                const [dataInicio, dataFim] = value;
                                if (new Date(dataInicio) > new Date(dataFim)) {
                                    callback(
                                        new Error(
                                            this.$t('mensagens.laudos.dataInicioMaiorQueTermino')
                                        )
                                    );
                                    return;
                                }
                            }
                            callback();
                        },
                        trigger: 'change'
                    }
                ]
            },
            carSelecionado: '',
            carExibicao: null,
            carsAdicionados: [],
            buscando: false,
            fileList: [],
            submitting: false
        };
    },
    emits: ['cancelar-modal', 'getLaudos'],
    mounted() {
        this.getCulturas();
    },
    computed: {
        formatPeriodoCobertura() {
            if (this.form.periodoCobertura.length === 2) {
                return `${this.formatarData(
                    this.form.periodoCobertura[0]
                )} à ${this.formatarData(
                    this.form.periodoCobertura[1]
                )}`;
            }
            return this.$t('mensagens.laudos.naoInformado');
        },
        formatCultura() {
            const cultura = this.culturas?.find(
                c => c.id === this.form.cultura
            );
            return cultura ? cultura.nome : this.$t('mensagens.laudos.naoInformado');
        }
    },
    methods: {
        voltar() {
            if (this.activeStep > 0) {
                this.activeStep--;
            }
        },
        handleFileChange(file, fileList) {
            const isZip = file.name.endsWith('.zip');
            if (!isZip) {
                this.$notify.error('Somente arquivos no formato .zip são permitidos.');
                this.fileList = fileList.filter(f => f.name.endsWith('.zip'));
                return;
            }
            this.fileList = fileList;
        },
        fecharModal() {
            this.$emit('cancelar-modal');
        },
        proximo() {
            if (this.activeStep === 0) {
                this.$refs.form.validate(valid => {
                    if (!valid) {
                        this.$notify.error(this.$t('mensagens.laudos.preenchaOsCamposObrigatorios'));
                        return;
                    }
                    this.activeStep++;
                });
            } else if (this.activeStep === 1 && this.carsAdicionados.length === 0) {
                this.$notify.error(this.$t('mensagens.laudos.adicioneUmCarParaProsseguir'));
            } else if (this.activeStep < 3) {
                this.activeStep++;
            }
        },
        async buscarCar() {
            if (!this.carSelecionado) {
                this.$notify.warning(
                    this.$t('mensagens.laudos.insiraUmNumeroValidoCar')
                );
                return;
            }
            if (
                this.carsAdicionados.find(
                    car => car.codigo === this.carSelecionado
                )
            ) {
                this.$notify.warning(this.$t('mensagens.laudos.carJaAdicionado'));
                return;
            }

            this.buscando = true;
            this.carExibicao = null;

            try {
                const { data } = await UtilsService.getDadosCARSemGeometria(
                    this.carSelecionado
                );
                if (data) {
                    this.carExibicao = {
                        codigo: this.carSelecionado,
                        areaHa: formatters.formatNumber(data.areaHa, 2),
                        municipioUF: `${data.nomeMunicipio} - ${data.uf}`,
                        situacao: data.situacao
                    };
                } else {
                    this.$notify.warning(this.$t('mensagens.laudos.nenhumCarEncontrado'));
                }
            } catch (error) {
                this.$notify.error(this.$t('mensagens.laudos.erroAoBuscarCar'));
            } finally {
                this.buscando = false;
            }
        },
        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.ativo'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.suspenso'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.cancelado'
                    );
            }
        },
        adicionarCar() {
            if (this.carExibicao) {
                this.carsAdicionados.push({ ...this.carExibicao });
                this.carExibicao = null;
                this.carSelecionado = '';
            }
        },
        removerCar(index) {
            this.carsAdicionados.splice(index, 1);
        },
        getCulturas() {
            LaudosService.getCulturas().then(({ data }) => {
                this.culturas = data;
            });
        },
        handleRemove() {
            this.fileList = [];
        },
        handleSuccess(response, file, fileList) {
            this.fileList = fileList;
        },
        formatarData(data) {
            if (!data) return '';

            const d = new Date(data);
            
            if (isNaN(d.getTime())) {
                return '';
            }

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            return `${day}/${month}/${year}`;
        },
        montarPayload() {
            let dataInicio = null;
            let dataFim = null;
            if (this.form.periodoCobertura.length === 2) {
                dataInicio = new Date(this.form.periodoCobertura[0]);
                dataFim = new Date(this.form.periodoCobertura[1]);
            }

            const carsVinculados = this.carsAdicionados.map(car => ({
                codigo: car.codigo
            }));

            return {
                informacaoLaudos: [
                    {
                        areaFinanciadaHa: Number(this.form.areaFinanciada),
                        dataInicioCobertura: dataInicio,
                        dataFimCobertura: dataFim,
                        culturaId: this.form.cultura,
                        tipoLaudoId: this.tipoLaudo,
                        carsVinculados: carsVinculados
                    }
                ]
            };
        },

        async submit() {
            this.submitting = true;
            const payload = this.montarPayload();

            if (this.fileList.length === 0) {
                this.$notify.error(this.$t('mensagens.laudos.anexarArquivoparaContinuar'));
                return;
            }

            const arquivo = this.fileList[0].raw || this.fileList[0];
            
            try {
                await LaudosService.cadastrarLaudoComArquivo(payload, arquivo);
                this.$emit('getLaudos');
                this.$emit('cancelar-modal');
                this.$notify.success(this.$t('mensagens.laudos.solicitacaoEnviadaComSucesso'));
            } catch (error) {
                let chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudo';
                if (error.response.data === '[ERRO_KEYCLOAK]') {
                    chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudoKeyckoak';
                } else if (error.response.data === '[ERRO_SEM_PERMISSAO]') {
                    chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudoSemPermissao';
                }

                this.$notify.error({
                    message: this.$t(chaveMensagemErro),
                    duration: 15000
                });
            } finally {
                this.submitting = false;
            }
        }
    }
};
</script>

<style scoped>
#etapas-laudo {
    padding: 10px;
}

.pesquisa-car {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.result-box {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.car-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
}

.informacoes-analisadas {
    padding: 10px 10px 0px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    background-color: #f9f9f9;
}

.car-item-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
}

.bold {
    font-weight: bold;
}

.el-steps {
    background-color: #fafafa;
    border: 1px solid #dcdfe6;
    padding: 20px;
    border-radius: 8px;
}

.form-container {
    border: 1px solid #dcdfe6;
    padding: 20px;
    border-radius: 8px;
    margin: 20px 0;
}

.buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.el-form-item {
    margin-bottom: 20px !important;
}

.icon-button {
    height: 50px;
}

.upload-demo {
    border: 2px dashed #dcdfe6;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    background-color: #fafafa;
    color: #606266;
}

.file-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 10px;
    margin-top: 10px;
    background-color: #f9f9f9;
}

.buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}
</style>
